import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface HorizontalContentCollectionProps {
  className?: string
  splitLeft?: boolean
  splitCenter?: boolean
  leftWidthPercentage?: number
}

const HorizontalContentCollection: React.FC<
  React.PropsWithChildren<HorizontalContentCollectionProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        align-items: flex-start;

        & > *:first-child {
          width: ${props.leftWidthPercentage
            ? css`
                ${props.leftWidthPercentage}%;
              `
            : props.splitCenter
              ? css`
                50%;
              `
              : props.splitLeft
                ? css`
                  45%;
                `
                : css`
                    55%;
                  `};
          flex-grow: 2;

          ${getBreakpointDown(breakpointSizes.SM)(css`
            width: 100%;
          `)}
        }

        & > *:nth-child(n + 2) {
          margin-left: 20px;
          width: ${props.leftWidthPercentage
            ? css`
                ${100 - props.leftWidthPercentage}%;
              `
            : props.splitCenter
              ? css`
                50%;
              `
              : props.splitLeft
                ? css`
                  55%;
                `
                : css`
                    45%;
                  `};

          ${getBreakpointOnly(breakpointSizes.MD)(css`
            margin-left: 20px;
          `)}

          ${getBreakpointDown(breakpointSizes.SM)(css`
            margin-top: 20px;
            margin-left: 0px;
            width: 100%;
          `)}
        }

        ${getBreakpointDown(breakpointSizes.SM)(css`
          flex-direction: column;
        `)}
      `}
    >
      {props.children}
    </div>
  )
}

export default HorizontalContentCollection
